var version = '0.16.0';
export default version;


// WEBPACK FOOTER //
// ./src/js/version.js